import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { map, Observable, of } from 'rxjs';
import { ODataRequest } from '../utilities/sdk-base/o-data-request';
import { PagingResponse } from '@models/paging-response.model';
import { ArchiveJobResourceToArchiveJobMapper } from "../models/mappers/archive-job/archive-job-resource-to-archive-job.mapper";
import { ArchiveJobToArchiveJobResourceMapper } from "../models/mappers/archive-job/archive-job-to-archive-job-resource.mapper";
import { ArchiveJobResource } from "../models/resource/archive-job.resource";
import { ArchiveJob } from '../models/archive-job.model';
import { Collection } from "../models/ui/collection.model";

const archiveJobResourceToArchiveJobMapper = new ArchiveJobResourceToArchiveJobMapper();
const archiveJobToArchiveJobResourceMapper = new ArchiveJobToArchiveJobResourceMapper();

@Injectable({
	providedIn: 'root'
})
export class ArchiveJobSdk extends SdkBase {
	constructor(injector: Injector) {
		super(injector);
	}

	public list(skip: number, take: number) {
		const request = new ODataRequest('get', 'ArchiveJobs')
			.$top(take)
			.$skip(skip);
		return this.makeODataRequest$<PagingResponse<ArchiveJobResource>>(request, 'api2').pipe(
			map((response) =>
				new Collection<ArchiveJob>({
					items: archiveJobResourceToArchiveJobMapper.mapCollection(response.value),
					totalItems: response.count
				})));
	}

	public get(archiveJobId: string): Observable<ArchiveJob> {
		const request = new ODataRequest('get', `ArchiveJobs/${archiveJobId}`);
		return this.makeODataRequest$<ArchiveJobResource>(request, 'api2').pipe(
			map((response) =>
				archiveJobResourceToArchiveJobMapper.map(response))
		);
	}

	public create(archiveJob: ArchiveJob): Observable<void> {
		if (archiveJob) {
			const mapper = new ArchiveJobToArchiveJobResourceMapper();
			const resource = mapper.map(archiveJob);
			const request = new ODataRequest('post', `ArchiveJobs`, resource);
			return this.makeODataRequest$(request, 'api2');
		}
		return of(null);
	}

	public put(archiveJob: ArchiveJob): Observable<void> {
		if (archiveJob) {
			const target = archiveJobToArchiveJobResourceMapper.map(archiveJob);
			const request = new ODataRequest('put', `ArchiveJobs`,target.archiveJobId, target);
			return this.makeODataRequest$(request, 'api2');
		}
		return of(null);
	}

	public delete(archiveJobId: string): Observable<void> {
		if (archiveJobId) {
			const request = new ODataRequest('delete', `ArchiveJobs`, archiveJobId);
			return this.makeODataRequest$(request, 'api2');
		}
		return of(null);
	}
}
